/**
 * Announcements page
 *
 * @copyright 2021 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import { format } from 'date-fns';

injector.injectClass(class extends Script {
    onLoad() {
        $('.announcement-section .datetime').each(function () {
            const date = $(this).data('datetime');
            $(this).html(format(date, 'EEEE, MMMM d h:mm a'));
        });
    }
}, ['announcements']);
